<template>
    <!-- AgentCard.vue -->
    <v-slide-y-transition hide-on-leave>
        <v-card
            :key="status.uuid"
            :color="status.color"
            class="fill-height"
            dark
        >
            <!-- Title -->
            <v-card-title :class="`${baseClass} text-xl-h2`">
                <div class="d-inline-block text-truncate">
                    {{ item.extension }} - {{ item.name }}
                </div>
            </v-card-title>
            <!-- Value and Duration -->
            <v-card-text>
                <div :class="`${baseClass}`">
                    {{ status.name }}
                    <v-icon large v-text="status.icon"></v-icon>
                </div>
                <div :class="`${baseClass}`">
                    {{ status.startTime }}
                </div>
            </v-card-text>
        </v-card>
    </v-slide-y-transition>
</template>

<script>
    export default {
        name: 'AgentCard',
        data: () => ({
            baseClass: 'font-weight-bold text-h4 white--text'
        }),
        props: {
            /**
             * The agent object i.e. {uuid, name, extension, status: {uuid, name, startTime, statusType, isSystemStatus, color, icon}}
             */
            item: {
                type: Object,
                required: true
            },
            /**
             * The height of the card
             */
            height: {
                type: Number
            }
        },
        computed: {
            status () {
                const vm = this
                return vm.item.status || {}
            }
        }
    }
</script>
